import { parse } from 'querystring';
// import { getIntl } from 'umi';
import { notification as n } from 'antd';

n.config({
  maxCount: 1,
});

export const getPageQuery = () => parse(window.location.href.split('?')[1]);

/**
 * 获取提示信息
 * @param code 业务状态码
 */
export const getBizMessage = (code) => {
  const prefix = 'common.tips.';
  const msg = getMessage({
    id: 'common.unknown.error.tips',
  });

  console.log(msg);
  return msg.toString() ? msg : 'error';
};

export const getMessage = (obj) => {
  // return getIntl().formatMessage(obj);
};

/**
 * 通知
 * @param message
 * @param description
 */
export const notification = {
  error: ({ message, description, msg }) => {
    n.error({
      message: message ? message : msg,
      description,
      duration: 5,
    });
  },
  success: ({ message, description }) => {
    n.success({
      message,
      description,
      duration: 2,
    });
  },
  warning: ({ message, description, msg }) => {
    n.warning({
      message: message ? message : msg,
      description,
      duration: 5,
    });
  },
};

/**
 * 数值千分位格式化
 */
export const formatTimeNumber = (text) => {
  if (text && Number(text) === 0) {
    return 0;
  }
  return text.toString().length === 1 ? '0' + text : text;
};

/**
 * 数值千分位格式化
 */
export const formatThousand = (text) => {
  if (text && Number(text) === 0) {
    return 0;
  }
  return text ? text.toLocaleString() : 0;
  // return text
  //   ? `${text}`
  //       .replace(/^(0+)|[^\d]+/g, '')
  //       .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  //   : 0;
};

/**
 * 数值千分位格式化
 */
export const formatThousandKM = (text) => {
  if (text && Number(text) === 0) {
    return 0;
  }
  if (text.toString().length >= 7) {
    text = (text / 1000000).toFixed(2) + 'm';
  } else if (text.toString().length >= 5) {
    text = (text / 1000).toFixed(2) + 'k';
  }
  return text;
};

/**
 * 数值转为中文
 */
export const formatChinaNumber = (text) => {
  if (text && Number(text) === 0) {
    return 0;
  }
  if (text.toString().length >= 5) {
    text = (text / 10000).toFixed(1) + '万';
  }

  return text;
};

/**
 * 拼接get请求url参数
 * 若url中有特殊符号，需另行encode，尤其是'#'
 */
export const formatUrlParams = (url, obj) => {
  if (typeof obj !== 'object') {
    return url;
  }

  let paramStr = '';
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] || obj[key] === 0) {
        paramStr = paramStr + '&' + key + '=' + obj[key];
      }
    }
  }
  if (paramStr !== '') {
    url += '?' + paramStr.slice(1, paramStr.length);
  }
  return url;
};

/**
 * 获取当前时间年月日时分秒
 */
export const formatDate = () => {
  const now = new Date(); // 获取当前时间
  const year = now.getFullYear(); // 年份
  const month = now.getMonth() + 1; // 月份，注意月份范围是0~11，需要加1
  const day = now.getDate(); // 日期
  const hour = now.getHours(); // 小时
  const minute = now.getMinutes(); // 分钟
  const second = now.getSeconds(); // 秒钟

  // 格式化时间
  const formattedTime = `${year}-${padZero(month)}-${padZero(day)} ${padZero(hour)}:${padZero(minute)}:${padZero(
    second
  )}`;

  // 补零函数
  function padZero(num) {
    return num < 10 ? `0${num}` : `${num}`;
  }
  return formattedTime;
  // console.log(formattedTime); // 输出时间字符串：例如 "2021-08-16 15:30:45"
};
// 颜色转换函数
export const convertColorToRGBA = (hex, d) => {
  // 去除可能存在的 # 号
  hex = hex.replace('#', '');

  // 分别提取 R、G、B 分量
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  // 计算 A 分量，默认为不透明（1）
  // 返回包含 R、G、B、A 值的对象
  return `rgba(${r},${g},${b},${d})`;
};

export const generateTimestampString = () => {
  // 获取当前时间戳
  const timestamp = Date.now();

  // 生成随机6位字符
  const randomCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * randomCharacters.length);
    randomString += randomCharacters[randomIndex];
  }

  // 拼接时间戳和随机字符串
  const result = timestamp + randomString;

  return result;
};

export const generateUUID = () => {
  const timestamp = Date.now(); // 获取当前时间戳
  const randomId = Math.random().toString(36).substr(2, 9); // 生成随机字符串作为ID
  return `${randomId}${timestamp}`; // 结合ID和时间戳返回
};
/**
 *
 * 当前时间，格式yyyy-MM-dd HH:mm:ss
 */
export const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const isContentInArray = (content, array) => {
  // 将数组中所有字符串转换为小写
  const lowerCaseArray = array.map((item) => item.toLowerCase());

  // 将目标字符串转换为小写，然后检查是否存在于数组中
  return lowerCaseArray.includes(content.toLowerCase());
};
